import { MatTabGroup } from "@angular/material/tabs";

/**
 * Refresh the current tab using the tab transition.
 *
 * Used to render the tab content without reloading the page (also avoid rendering issues)
 *
 * @param tabGroup The tab group where the tab is located.
 */
export function refreshTab(tabGroup: MatTabGroup): void {
  const selectedTabIndex = tabGroup.selectedIndex;
  tabGroup.selectedIndex = -1;
  setTimeout(() => {
    tabGroup.selectedIndex = selectedTabIndex;
  }, 0);
}
